import React from 'react';
import ReactLoading from 'react-loading';
import logo from 'url:../../../assets/images/alice-logo.png';
import styles from './styles.module.scss';

export default function AuthLoading() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          src={logo}
          alt="Alice Logo"
          className={styles.logo}
        />
        <ReactLoading
          type="spinningBubbles"
          height={80}
          width={80}
          delay={0}
          color="#F96D00"
        />
      </div>
    </div>
  );
}

